import { render, staticRenderFns } from "./Contentacc.vue?vue&type=template&id=6de96a7b&"
import script from "./Contentacc.vue?vue&type=script&lang=js&"
export * from "./Contentacc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports